import Vue from 'vue';
import { Dialog } from 'vant';
import { MutationTree, ActionTree, Module, GetterTree } from 'vuex';
import { VuexState } from '@/interfaces/vuexStateInterface';
import checkInApi from '@/apis/checkIn/checkIn';
import router from '@/router';
import { post } from '@/utils/network';
import { is_weixin } from '@/components/Common/Enclosure/basis';
import {geMobiletCurrentURL} from '@/utils/common';

Vue.use(Dialog);
const mutations: MutationTree<VuexState> = {
  setReplyType(state, data) {
    // state.replyType = data
  }
};
const getters: GetterTree<VuexState, VuexState> = {
  getReplyType(state) {
    // return state.replyType
  }
};

export function getWxConfig(params: { url: string}) {
  return post<{
    url: string;
  }>('/WechatApi/getSignPackage',params);
}

export const actions: ActionTree<VuexState, VuexState> = {
  // @ts-ignore 检测未完成考勤
  getNotFinishAttenceStudent(
    ctx,
    data: {
      courseId: string;
      classId?: string;
    }
  ) {
    const courseId = (data && data.courseId) || (data && data.classId) || sessionStorage.getItem('courseId');
    if (!courseId || courseId == "0" || courseId == null || courseId == undefined){
      return;
    }
    let currentLocation:string = window.localStorage.getItem('currentLocation') as string;
    if(currentLocation!=null && currentLocation.indexOf("ShareClass")>=0){
      return
    }
    //如果当前已经在签到页面就不要弹窗了
    const currentUrl:string = geMobiletCurrentURL();
    if(currentUrl.indexOf("/checkIn/studentGPS")>0 || currentUrl.indexOf("checkIn/studentNumber")>0){
      return;
    }
    // eslint-disable-next-line import/no-named-as-default-member
    checkInApi.getNotFinishAttenceStudent(courseId).then((res: any) => {
      if (!res.lists || res.lists.length === 0) {
        return;
      }
      // type  0:传统考勤,1:数字考勤,2:GPS考勤,3:二维码,4:签入签出考勤
      let message = '';
      let confirmButtonText = '';
      let path = '';
      switch (res.lists[0].type) {
        case '1':
          message = '班级老师正在【数字考勤】，请及时签到';
          confirmButtonText = '马上签到';
          path = '/checkIn/studentNumber';
          break;
        case '2':
          message = '班级老师正在【GPS考勤】，请及时签到';
          confirmButtonText = '点击完成签到';
          path = '/checkIn/studentGPS';
          break;
        case '3':
          message = '本次考勤为扫码考勤，请您用微信扫一扫老师的大屏幕的二维码进行签到';
          confirmButtonText = '立即扫一扫';
          break;
        case '4':
          message = '班级老师正在【签入考勤】，请及时签到';
          confirmButtonText = '马上签到';
          path = '/checkIn/studentGPS';
          break;
      }
      Dialog.confirm({
        title: '是否完成签到',
        message,
        confirmButtonText,
        cancelButtonText: '一会再说'
      }).then(() => {
        if (path) {
          router.push({
            path,
            query: { id: res.lists[0].id }
          });
        }else if(res.lists[0].type == 3){
          if(!is_weixin()){
            Dialog.alert({
              title:'温馨提醒',
              message:'请使用微信扫一扫',
            });
            return;
          }
          let newUrl = geMobiletCurrentURL();
          getWxConfig({url:newUrl}).then((config:any) => {
            // @ts-ignore
            // eslint-disable-next-line no-undef
            wx.config({
              debug: false,
              appId: config.appId,
              timestamp: ""+config.timestamp,
              nonceStr: config.nonceStr,
              signature: config.signature,
              jsApiList: ['checkJsApi','scanQRCode']
            });
            // @ts-ignore
            // eslint-disable-next-line no-undef
            wx.ready(function () {
                // @ts-ignore
                // eslint-disable-next-line no-undef
                wx.checkJsApi({
                  jsApiList: ['scanQRCode'],
                  success: function (res:any) {
                  }
                });
                // @ts-ignore
                // eslint-disable-next-line no-undef
                wx.scanQRCode({
                  needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                  scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
                  success: function (res1:any) {
                  },
                  error:function(res2:any){
                    Dialog.alert({
                      title:'温馨提醒',
                      message:'请用微信扫一扫，即可完成签到',
                    });
                  }
                });
            });
          });
        }
      });
    });
  }
};

const checkInStore: Module<VuexState, VuexState> = {
  getters,
  mutations,
  actions
};

export default checkInStore;
